import {create} from 'zustand';

/**
 * Bridges the active Care Journey pre-review step to the task-detail header so the "Save draft"
 * action can sit in the top navigation beside Reject Referral (CARECO-6282), rather than inside the
 * review content beside Back/Next.
 *
 * The header is published through a global portal (usePageHeaderContent / PageTitleContext) that is
 * rendered outside TaskDetailPage's subtree, so a React context cannot bridge the two. The active
 * CareJourneyPreReview step registers its save handler + current state here; PreReviewSaveDraftHeader
 * Action reads it. `save` is null whenever no pre-review step is mounted, so the header self-gates
 * (renders nothing) exactly like ReferralRejectHeaderAction.
 */
export interface PreReviewDraftState {
  save: (() => void) | null;
  isSaving: boolean;
  disabled: boolean;
  setDraftAction: (action: {save: () => void; isSaving: boolean; disabled: boolean}) => void;
  clearDraftAction: () => void;
}

export const usePreReviewDraftStore = create<PreReviewDraftState>((set) => ({
  save: null,
  isSaving: false,
  disabled: false,
  setDraftAction: (action) => set(action),
  clearDraftAction: () => set({save: null, isSaving: false, disabled: false}),
}));
